enum SystemTaskType {
  ReadNote = 'ReadNote',
  DoIntakeCall = 'DoIntakeCall',
  RequestFile = 'RequestFile',
  CaseApproved = 'CaseApproved',
  CaseDeclined = 'CaseDeclined',
  CheckDocuments = 'CheckDocuments',
  CheckPhonecalls = 'CheckPhonecalls',
  CheckEmails = 'CheckEmails',
  CheckAppointments = 'CheckAppointments',
  CloseCase = 'CloseCase',
  CheckCase = 'CheckCase',
  DeliverEstimate = 'DeliverEstimate',
  AcceptEstimate = 'AcceptEstimate',
  RequestEstimate = 'RequestEstimate',
  AcceptInvoice = 'AcceptInvoice',
  SpreadsheetFailed = 'SpreadsheetFailed',
  DeliverInvoice = 'DeliverInvoice',
  RequestInvoice = 'RequestInvoice',
  BookInvoiceInExactOnline = 'BookInvoiceInExactOnline',
  AcceptPurchaseCreditNote = 'AcceptPurchaseCreditNote',
  BookSalesInvoice = 'BookSalesInvoice',
  DraftSalesInvoice = 'DraftSalesInvoice',
  CreateAutomaticMessageTemplate = 'CreateAutomaticMessageTemplate',
  ScheduleWork = 'ScheduleWork',
  EmailFailedToSend = 'EmailFailedToSend',
  CreatingInvitationsBatchFailed = 'CreatingInvitationsBatchFailed',
  SendingEnvelopeToIsabelFailed = 'SendingEnvelopeToIsabelFailed',
  RegisterFirstAppointment = 'RegisterFirstAppointment',
  ProcessingError = 'ProcessingError',
  RegisterWorksite = 'RegisterWorksite',
  FollowUpOutboundOffer = 'FollowUpOutboundOffer',
}

export default SystemTaskType;
